import { usePointUnbindStream } from '@entities/point';

import { toast } from '@shared/ui';
import { DEFAULT_ERROR_MESSAGE } from '@shared/config';
import { TEXTS } from 'application/pages/PointsPage/renderer/texts';

import { StreamUnbindModalViewModelProps } from './types';

const useStreamUnbindModalViewModel = ({ pointId, close }: StreamUnbindModalViewModelProps) => {
  const { request, loading } = usePointUnbindStream();

  const handleClose = () => {
    if (!loading) {
      close();
    }
  };

  const handleUnbind = async () => {
    try {
      const ok = await request(pointId);

      if (!ok) {
        throw new Error();
      }

      close();

      toast.info(TEXTS.POINT_STREAM_UNBIND_MODAL_SUCCESS_TEXT);
    } catch {
      toast.error(DEFAULT_ERROR_MESSAGE);
    }
  };

  return {
    handleClose,
    handleUnbind,
    isLoading: loading,
  };
};

export default useStreamUnbindModalViewModel;
